'use client';

import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { Warning } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { Button } from '../../atoms/Button';
import { ConfirmationPopupProps } from './ConfirmationPopup.types';

const contentBaseClasses =
  'z-modal fixed overflow-y-auto ' +
  'py-4 rounded-lg w-[328px] ' +
  'bg-white shadow-card outline-none border border-grey-200 ' +
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-hover ' +
  'left-1/2 right-auto -translate-x-1/2 bottom-auto top-1/2';

const contentTransitionClasses =
  'transition-all duration-300 ' +
  'data-[state=closed]:opacity-0 data-[state=open]:opacity-100 ' +
  'data-[state=closed]:-translate-y-0 data-[state=open]:-translate-y-1/2';

export const ConfirmationPopup = (props: ConfirmationPopupProps) => {
  const {
    id,
    title,
    trigger,
    content,
    cta = 'Delete',
    cancel = 'Cancel',
    onDeleteReview,
    onCancel,
    className = '',
  } = props;

  return (
    <AlertDialog.Root>
      <AlertDialog.Trigger asChild>
        {trigger ?? (
          <Button.v2
            iconLeft="Trash"
            label={cta}
            shape="square"
            size="xsmall"
            variant="tertiary-red-monochrome"
          />
        )}
      </AlertDialog.Trigger>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-50 bg-black/50 transition duration-300 data-[state=closed]:animate-overlayHide data-[state=open]:animate-overlayShow " />
        <AlertDialog.Content
          className={c(contentBaseClasses, contentTransitionClasses, className)}
        >
          <div className="flex flex-col divide-y divide-grey-200">
            <div className="px-4 pb-2">
              <AlertDialog.Title className="flex gap-2.5 text-2xl font-semibold text-grey-900 ">
                <Warning
                  size={24}
                  weight="fill"
                  className="self-center fill-red-600"
                />
                {title}
              </AlertDialog.Title>
            </div>
            <div className="p-4">
              <AlertDialog.Description className="text-base">
                {content}
              </AlertDialog.Description>
            </div>
            <div className="flex flex-row items-center justify-end gap-4 px-4 pt-4">
              <AlertDialog.Cancel asChild>
                <Button.v2
                  label={cancel}
                  className="w-auto px-4"
                  variant="tertiary-black-monochrome"
                  size="medium"
                  shape="square"
                  onClick={onCancel} // optional if additional logic is needed
                />
              </AlertDialog.Cancel>
              <AlertDialog.Action asChild>
                <Button.v2
                  label={cta}
                  className="w-auto px-4"
                  variant="primary-red-monochrome"
                  size="medium"
                  shape="square"
                  onClick={() => onDeleteReview(id, true)}
                />
              </AlertDialog.Action>
            </div>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};
